// import React, { useState, useContext, ChangeEvent, useRef, useEffect } from "react";
// import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../../context/AuthContext";
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
// import { storage } from "../../../firebase/firebase";
// import { doc, collection } from "firebase/firestore";
// import { useNavigationBar } from "../../../context/NavigationContext";
// import * as Yup from "yup";
// import { SKStory } from "../../../models/SKStory";
// import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
// import { getArtefactIcon } from "../../../models/SKArtifact";

// const CreateImageContent = () => {
//   let inputRef = useRef<HTMLInputElement>(null);
//   const { contentData, updateContentData } = useContext(CreateArtifactContext);
//   const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
//   const fbContext = useAuth();

//   const navigate = useNavigate();

//   const [uploading, setUploading] = useState<boolean>(false);

//   const [images, setImages] = useState<{ id: string; file: File }[]>([]);

//   const { setNavProps } = useNavigationBar();
//   // import { useNavigationBar } from "../../../context/NavigationContext";
//   useEffect(() => {
//     setNavProps({
//       backArrow: false,
//       title: "Content",
//       subtitle: capitalizeFirstLetter(contentData.type ?? ""),
//       icon: contentData.type ? getArtefactIcon(contentData.type) : undefined,
//       buttonTitle: "Submit",
//       filterOption: false,
//       enableLink: contentData.coverImage ? true : false,
//       onFilter: () => {},
//       onNext: () => navigate("../selectTopic"),
//     });
//   }, [setNavProps, contentData]);

//   const schema = Yup.object().shape({
//     message: Yup.string().required(`Text is required!`).max(500),
//   });

//   const onChange = async (event: React.FocusEvent<HTMLTextAreaElement>) => {
//     const { name, value } = event.target;
//     updateContentData({ ...contentData, title: value });
//     // const isValid = await validateForm(name, value);
//     await validateForm(name, value);
//   };
//   const validateForm = async (name: string, value: string) => {
//     try {
//       await schema.validateAt(name, { [name]: value });

//       setErrors(prev => {
//         const { [name]: _, ...rest } = prev; // Destructure out the key to remove and capture the rest
//         return rest;
//       });
//       return true;
//     } catch (err) {
//       let error = err as Yup.ValidationError;
//       setErrors(prev => ({ ...prev, [name]: error.message }));
//     }
//   };

//   //   const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
//   //     const files = Array.from(event.target.files);
//   //     const newImages = files.map(file => {
//   //       return {
//   //         id: URL.createObjectURL(file),
//   //         file: file,
//   //       };
//   //     });
//   //     setImages(prev => [...prev, ...newImages]);
//   //   };

//   //   const onDrop = useCallback(
//   //     (acceptedFiles: File[]) => {
//   //       setFiles([...files, ...acceptedFiles.slice(0, 4 - files.length)]);
//   //     },
//   //     [files]
//   //   );

//   const uploadFiles = async () => {
//     // await setDoc(doc(db, COLLECTIONS.USERS, auth.currentUser.uid), { email, firstName, lastName, phone }, { merge: true });

//     if (!fbContext) {
//       return;
//     }
//     const newDocRef = doc(collection(fbContext?.db, "storeContents"));

//     setUploading(true);
//     const uploadPromises = images.map(({ id, file }) => {
//       return new Promise((resolve, reject) => {
//         const storageRef = ref(storage, `storeContent/${newDocRef.id}_${file.name}`);
//         const uploadTask = uploadBytesResumable(storageRef, file);
//         uploadTask.on(
//           "state_changed",
//           snapshot => {
//             const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             console.log("upload is" + progress + "% done");
//             switch (snapshot.state) {
//               case "paused":
//                 console.log("Upload paused");
//                 break;
//               case "running":
//                 console.log("Upload running");
//                 break;
//               default:
//                 break;
//             }
//           },
//           error => {
//             console.log(error);
//             reject(error);
//           },
//           () => {
//             getDownloadURL(uploadTask.snapshot.ref)
//               .then(downloadedURL => {
//                 let images = (contentData as SKStory).imageUrls ?? [];
//                 images.push(downloadedURL);
//                 updateContentData(prevData => ({ ...prevData, images }));
//                 resolve(downloadedURL);
//               })
//               .catch(reject);
//           }
//         );
//       });
//     });
//     await Promise.all(uploadPromises);
//     setUploading(false);
//   };

//   const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
//     console.log(event.target.files);
//     const files = event.target.files;
//     if (files) {
//       const array = Array.from(files);
//       const newImages = array.map(file => {
//         return {
//           id: URL.createObjectURL(file),
//           file: file,
//         };
//       });
//       setImages(prev => [...prev, ...newImages]);
//     }

//     //OR
//     //console.log(inputRef.current.files)
//   };

//   const removeImage = (id: string) => {
//     setImages(images.filter(image => image.id !== id));
//     URL.revokeObjectURL(id);
//   };

//   //   const uploadFiles = async () => {
//   //     setUploading(true);
//   //     const uploadPromises = files.map(file => {
//   //       const reff = ref(storage, "images/");
//   //       return reff.put(file).then(async () => {
//   //         const url = await reff.getDownloadURL();
//   //         setUrls(prevUrls => [...prevUrls, url]);
//   //       });
//   //     });
//   //     await Promise.all(uploadPromises);
//   //     setUploading(false);
//   //   };

//   return (
//     <>
//       <div className="flex flex-col gap-2 p-2">
//         <span className="text-lg font-bold">Add Photos</span>
//         <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-400 dark:text-white">
//           Maximum 3 photos. Use Stories to upload more than 3 photos.
//         </label>
//         <div
//           className="relative p-4 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer"
//           onClick={() => {
//             images?.length >= 3 ? alert("You can upload only 3 images per photo artifact") : inputRef?.current?.click();
//           }}
//         >
//           <input
//             ref={inputRef}
//             type="file"
//             id="files"
//             name="files"
//             accept="image/*"
//             multiple
//             onChange={handleChangeFile}
//             className="absolute top-0 flex items-center content-center w-full h-full opacity-0 letf-0"
//             disabled={images?.length >= 3 ? true : false}
//           />

//           <div className="flex flex-wrap gap-4 mt-4">
//             {images.map(image => (
//               <div key={image.id} className="relative w-24 h-24 m-1">
//                 <img src={image.id} alt="" className="object-cover w-full h-full" />
//                 <button
//                   onClick={e => {
//                     e.stopPropagation();
//                     removeImage(image.id);
//                   }}
//                   className="absolute flex items-center justify-center w-[30px] h-[30px] text-xl text-white bg-black bg-opacity-50 rounded-full top-2 right-2"
//                 >
//                   &times;
//                 </button>
//               </div>
//             ))}

//             <label
//               htmlFor="file-input"
//               className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-10 h-10 text-2xl bg-gray-200 cursor-pointer"
//             >
//               +
//             </label>
//           </div>
//           <p className="text-gray-500">{images.length}/3</p>
//         </div>

//         <button
//           onClick={uploadFiles}
//           disabled={uploading || images.length === 0}
//           className={`mt-4 bg-blue-500 text-white py-2 px-4 rounded ${uploading ? "bg-gray-400" : "hover:bg-blue-600"}`}
//         >
//           {uploading ? "Uploading..." : "Upload Images"}
//         </button>
//         <div className="mt-4">
//           {(contentData as SKStory).imageUrls?.map((url, index) => (
//             <div key={index}>
//               <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-500">
//                 View Uploaded Image {index + 1}
//               </a>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="relative w-full min-w-[200px]">
//         <span className="text-lg font-bold">Add Post Text</span>
//         <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-400 dark:text-white">
//           Maximum text length of 500 characters. Use Journals and Letters to post longer text.
//         </label>
//         <textarea
//           name="message"
//           className="h-full min-h-[100px] w-full resize-none rounded-[7px] border border-blue-gray-200 p-2"
//           placeholder=" "
//           onChange={onChange}
//           value={contentData.title}
//         ></textarea>
//         {errors.message && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.message}</span>}
//         {!errors.message && (
//           <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">{500 - (contentData.title?.length ?? 0)} Characters Remaining.</span>
//         )}
//       </div>
//     </>
//   );
// };

// export default CreateImageContent;

import React from "react";

function createImage() {
  return <div>createImage</div>;
}

export default createImage;
